import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { GenericModalComponent } from './generic-modal.component';

@Injectable({
  providedIn: 'root',
})
export class GenericModalService {
  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  show(title: string, body: string) {
    if (this.modalRef) {
      this.modalRef.close();
    }

    this.modalRef = this.modalService.open(GenericModalComponent);
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.body = body;
    this.modalRef.componentInstance.close.subscribe(() =>
      this.modalRef.close()
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/generic-modal/generic-modal.service.ts